import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function commonProps() {
  return theme;
}
